/**
 * Regex for Email
 */
export const emailRegex = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/

/**
 * Regex for phone number without length validation
 */
export const PHONE_NUMBER_REGEX = /^[\d-]*$/

/**
 * Regex for strong password
 */
export const STRONG_PASSWORD_REGEX = /^.{8,}$/

export const CHECK_CONTEST_URI_REGEX = /^\/c\/([^/]+)(\/|$)/

export const SUBDOMAIN_VALIDATION_REGEX =
  /^[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?$/

export const NON_EMPTY_TAGS_REGEX = /^[a-zA-Z0-9\s]+$/

export const EMAIL_DOMAIN_REGEX = /^[a-zA-Z0-9.-]+\.(\*|[a-zA-Z]{2,})$/

/**
 * Regex for name (only characters and spaces allowed)
 */
export const NAME_REGEX = /^[a-zA-Z\s]+$/

/**
 * Regex for tenant/company name (letters, numbers, dots, and spaces allowed)
 */
export const TENANT_NAME_REGEX = /^[A-Za-z0-9. ]+$/


